export enum StoragePlanUOM {
  FLAT_RATE = 'Flat_rate',
  SIX_MONTHS = 'Six_months',
  UNIT = 'Unit',
}
